(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4436],{

/***/ 64436:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pagination; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./components/pagination/Pagination.module.scss
var Pagination_module = __webpack_require__(51126);
var Pagination_module_default = /*#__PURE__*/__webpack_require__.n(Pagination_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/pagination/Pagination.js


var _excluded = ["isActive", "disabled", "href", "asPath", "shallow", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var PaginationItem = function PaginationItem(_ref) {
  var _ref$isActive = _ref.isActive,
      isActive = _ref$isActive === void 0 ? false : _ref$isActive,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      href = _ref.href,
      asPath = _ref.asPath,
      shallow = _ref.shallow,
      children = _ref.children,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  if (isActive || disabled) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: (0,clsx_m/* default */.Z)((Pagination_module_default())["pagination-link"], (props.prev || props.next) && (Pagination_module_default())["pagination-link-prev-next"], props.prev && (Pagination_module_default())["pagination-link-prev"], props.next && (Pagination_module_default())["pagination-link-next"], isActive && (Pagination_module_default())["pagination-link-active"], disabled && (Pagination_module_default())["pagination-link-disabled"]),
        children: children
      })
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: href,
      as: asPath,
      passHref: true,
      shallow: shallow,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        className: (0,clsx_m/* default */.Z)((Pagination_module_default())["pagination-link"], (props.prev || props.next) && (Pagination_module_default())["pagination-link-prev-next"], props.prev && (Pagination_module_default())["pagination-link-prev"], props.next && (Pagination_module_default())["pagination-link-next"]),
        children: children
      })
    })
  });
};

var PaginationEllipsis = function PaginationEllipsis(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: (0,clsx_m/* default */.Z)((Pagination_module_default())["pagination-link"], (props.prev || props.next) && (Pagination_module_default())["pagination-link-prev-next"], props.prev && (Pagination_module_default())["pagination-link-prev"], props.next && (Pagination_module_default())["pagination-link-next"], props.isActive && (Pagination_module_default())["pagination-link-active"], props.disabled && (Pagination_module_default())["pagination-link-disabled"], (Pagination_module_default())["pagination-link-ellipsis"]),
      children: "..."
    })
  });
};

var Pagination = function Pagination(_ref2) {
  var currentPage = _ref2.currentPage,
      lastPage = _ref2.lastPage,
      _ref2$shallow = _ref2.shallow,
      shallow = _ref2$shallow === void 0 ? true : _ref2$shallow;
  var router = (0,next_router.useRouter)();
  var pages = [];
  var maxNumberOfPages = 7;
  var current = +currentPage;
  var prevPage = current - 1;
  var pagesTotal = +lastPage;
  var href = router.pathname;
  var asPath = router.asPath.split('?')[0];
  var notNextjsQueries = Object.keys(router.query).reduce(function (acc, key) {
    if (router.pathname.indexOf("[".concat(key, "]")) === -1 && router.pathname.indexOf("[...".concat(key, "]")) === -1) {
      acc[key] = router.query[key];
    }

    return acc;
  }, {});
  delete notNextjsQueries.page;

  var page = function page(_page) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(PaginationItem, {
      href: {
        pathname: href,
        query: _page === 1 ? _objectSpread({}, notNextjsQueries) : _objectSpread(_objectSpread({}, notNextjsQueries), {}, {
          page: _page
        })
      },
      asPath: {
        pathname: asPath,
        query: _page === 1 ? _objectSpread({}, notNextjsQueries) : _objectSpread(_objectSpread({}, notNextjsQueries), {}, {
          page: _page
        })
      },
      isActive: current === _page,
      shallow: shallow,
      children: _page
    }, _page);
  };
  /* <- 1 2 3 4 5 6 7 -> */


  if (pagesTotal <= maxNumberOfPages) {
    for (var i = 1; i <= pagesTotal; i++) {
      pages.push(page(i));
    }
  } else {
    /* <- 1 2 3 4' 5 ... N -> */
    if (current < 5) {
      for (var _i = 1; _i <= 5; _i++) {
        pages.push(page(_i));
      }

      pages.push( /*#__PURE__*/(0,jsx_runtime.jsx)(PaginationEllipsis, {}, 'rest2'));
      pages.push(page(pagesTotal));
    } else if (current > pagesTotal - 4) {
      /* <- 1 ... N-4 N-3 N-2 N-1 N -> */
      pages.push(page(1));
      pages.push( /*#__PURE__*/(0,jsx_runtime.jsx)(PaginationEllipsis, {}, 'rest'));

      for (var _i2 = pagesTotal - 4; _i2 <= pagesTotal; _i2++) {
        pages.push(page(_i2));
      }
    } else {
      /* <- 1 ... 4 5' 6 ... N -> */
      pages = [].concat(page(1), /*#__PURE__*/(0,jsx_runtime.jsx)(PaginationEllipsis, {}, 'rest'), page(prevPage), page(current), page(current + 1), /*#__PURE__*/(0,jsx_runtime.jsx)(PaginationEllipsis, {}, 'rest2'), page(pagesTotal));
    }
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
    className: (Pagination_module_default()).pagination,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PaginationItem, {
      href: {
        pathname: href,
        query: prevPage === 1 ? _objectSpread({}, notNextjsQueries) : _objectSpread(_objectSpread({}, notNextjsQueries), {}, {
          page: prevPage
        })
      },
      asPath: {
        pathname: asPath,
        query: prevPage === 1 ? _objectSpread({}, notNextjsQueries) : _objectSpread(_objectSpread({}, notNextjsQueries), {}, {
          page: prevPage
        })
      },
      prev: true,
      disabled: current === 1,
      shallow: shallow,
      children: "\u041D\u0430\u0437\u0430\u0434"
    }, 'prev'), pages, /*#__PURE__*/(0,jsx_runtime.jsx)(PaginationItem, {
      href: {
        pathname: href,
        query: _objectSpread(_objectSpread({}, notNextjsQueries), {}, {
          page: current + 1
        })
      },
      asPath: {
        pathname: asPath,
        query: _objectSpread(_objectSpread({}, notNextjsQueries), {}, {
          page: current + 1
        })
      },
      next: true,
      disabled: current === pagesTotal,
      shallow: shallow,
      children: "\u0412\u043F\u0435\u0440\u0435\u0434"
    }, 'next')]
  });
};

/* harmony default export */ var pagination_Pagination = (Pagination);
;// CONCATENATED MODULE: ./components/pagination/index.js

/* harmony default export */ var pagination = (pagination_Pagination);

/***/ }),

/***/ 51126:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Pagination_pagination__RkAz_","pagination-link":"Pagination_pagination-link__OXZlw","pagination-link-prev-next":"Pagination_pagination-link-prev-next__d9L9k","pagination-link-prev":"Pagination_pagination-link-prev__LG9YL","pagination-link-next":"Pagination_pagination-link-next__wJvdq","pagination-link-active":"Pagination_pagination-link-active__i91QF","pagination-link-disabled":"Pagination_pagination-link-disabled__9jgWo","pagination-link-ellipsis":"Pagination_pagination-link-ellipsis__jAaSv","load":"Pagination_load__D1Ou8"};

/***/ })

}]);